import { AnyObject } from 'yup';
import { SchemaDescription } from '../lib';

export const isSchemaObjectDescription = <SchemaShape extends AnyObject>(value: unknown): value is SchemaDescription<SchemaShape> =>
    typeof (value as SchemaDescription<SchemaShape>).fields !== 'undefined' && (value as SchemaDescription<SchemaShape>).type === 'object';
